<template>
  <div class="edit">
    <h3>我的乘客</h3>
    <div class="info">
      <p class="base">基本信息</p>
      <el-form :model="info" ref="info" :rules="rules" label-width="125px" class="demo-ruleForm">
        <el-form-item
                label="乘客姓名："
                prop="name"
        >
          <el-input type="text" v-model="info.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="乘客手机号："
                prop="mobile"
        >
          <el-input type="text" v-model.number="info.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="乘客身份证号："
                prop="idCard"
        >
          <el-input type="text" v-model="info.idCard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="账号信息："
                prop="travelNo"
        >
          <el-input type="text" v-model="info.travelNo" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('info')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {reqPassengerChange, reqPassengerDetail} from '../../../api'
import {mobiles,idCard} from '../../../utils/phone'
export default {
  data() {
    let validPhone = (rule, value, callback) => {
      if(!mobiles(value)){
        callback(new Error('手机号码不正确'))
      }else{
        callback()
      }
    }
    let validCard = (rule, value, callback) => {
      if(!idCard(value)){
        callback(new Error('身份证不正确'))
      }else{
        callback()
      }
    }
    return {
      info: {
        name: '',
        mobile: '',
        idCard: '',
        travelNo: ''
      },
      rules: {
        name: [{required: true, message: '请输入乘客姓名', trigger: 'blur'}],
        mobile: [{required: true, message: '请输入乘客手机号', trigger: 'blur'}, {validator: validPhone, trigger: 'blur'}],
        idCard: [{required: true, message: '请输入乘客身份证号', trigger: 'blur'}, {validator: validCard, trigger: 'blur'}]
      }
    };
  },
  created() {
    if (this.$route.query.id) {
      reqPassengerDetail(this.$route.query.id).then(res => {
        if(res.code === 200){
          const {name, mobile, idCard, travelNo} = res.data.bussData
          this.info.name = name
          this.info.mobile = mobile
          this.info.idCard = idCard
          this.info.travelNo = travelNo
        }
      })
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const {id} = this.$route.query
          if(id) {
            this.info.id = id
          }
          reqPassengerChange(this.info).then(res => {
            if (res.code === 200) {
              console.log(res)
              if(res.data.bussData){
                if(id) {
                  this.$message({
                    message: '编辑成功',
                    type: 'success'
                  })
                }else {
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  })
                }
                this.$router.replace('/person/passenger')
              }
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
  .edit{
    h3{
      margin-top:60px;
      font-size: 24px;
    }
    .info{
      .base{
        margin:30px 0;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .el-input{
    width: 306px;
  }
  .el-button--primary{
    width: 306px;
    height: 48px;
    box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
    border-radius:24px;
    background: #61aee6;
    border-color:#61aee6;
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/EditPassenger.vue